import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Soundium "Complete your setup" bundle — AJAX add-to-cart wiring. SND-12184.
 *
 * The bundle markup + styles live in blocks/soundium-complementary.liquid. This module
 * owns the interactivity that the inline {% javascript %} block could NOT do: because the
 * inline theme-javascript bundle is a plain (non-module) script it cannot import
 * `@shopify/events`, so the old code dispatched a bare CustomEvent('cart:update') that
 * nothing in Horizon listens for — the item landed in the cart server-side but the drawer,
 * line items and header bubble never refreshed (needed a full page reload).
 *
 * Here we dispatch the theme's real CartLinesUpdateEvent (same contract as
 * component-cart-items.js): action 'add' + a deferred promise resolving to
 * { cart, detail: { sections, itemCount, ... } }. That makes cart-drawer auto-open,
 * cart-items morph the returned section HTML, and cart-icon bump the count — no reload.
 */
(function () {
  if (window.__sndCmpBundleInit) return;
  window.__sndCmpBundleInit = true;

  function fmt(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function recalc(box) {
    var mainPrice = parseInt(box.dataset.mainPrice || '0', 10);
    var total = mainPrice, save = 0, count = 1;
    box.querySelectorAll('.snd-cmp__input').forEach(function (inp) {
      if (inp.checked && !inp.disabled) {
        var disc = parseInt(inp.dataset.price || '0', 10);
        total += disc;
        count += 1;
        var row = inp.closest('.snd-cmp__row');
        var was = row && row.querySelector('.snd-cmp__was');
        if (was) {
          var wasCents = Math.round(parseFloat(was.textContent.replace(/[^0-9,]/g, '').replace(',', '.')) * 100);
          if (!isNaN(wasCents)) save += (wasCents - disc);
        }
      }
    });
    var t = box.querySelector('[data-total]'); if (t) t.textContent = fmt(total);
    var c = box.querySelector('[data-count]');
    if (c) {
      var itemTpl = box.dataset.textItem || '__COUNT__ item';
      var itemsTpl = box.dataset.textItems || '__COUNT__ items';
      c.textContent = (count === 1 ? itemTpl : itemsTpl).replace(/__COUNT__/g, count);
    }
    var si = box.querySelector('[data-save-inline]');
    if (si) {
      var youSaveTpl = box.dataset.textYouSave || 'You save __AMOUNT__';
      // Leading NBSP + "·" is part of the value, so an empty saving leaves no dangling separator.
      si.textContent = save > 0 ? '\u00a0\u00b7 ' + youSaveTpl.replace(/__AMOUNT__/g, fmt(save)) : '';
    }
    var sp = box.querySelector('[data-save-pill]'); if (sp) sp.style.display = save > 0 ? '' : 'none';
  }

  // Every cart-items-component on the page (the drawer, and the cart page if present)
  // so /cart/add.js returns their rendered section HTML for the morph.
  function cartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map(function (el) { return el.dataset.sectionId; })
      .filter(Boolean);
  }

  function handleAdd(btn, box) {
    var items = [{ id: box.dataset.mainVariant, quantity: 1 }];
    box.querySelectorAll('.snd-cmp__input').forEach(function (inp) {
      if (inp.checked && !inp.disabled) items.push({ id: inp.dataset.variant, quantity: 1 });
    });

    var label = btn.querySelector('span');
    var original = label ? label.textContent : '';
    btn.disabled = true;

    var sectionIds = cartSectionIds();
    var body = { items: items };
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    // Announce the update synchronously with a deferred promise, exactly like the theme's
    // native cart mutations. Dispatched from the bundle box (outside any dialog:modal), so
    // cart-drawer treats it as a fresh add and auto-opens.
    var deferred = CartLinesUpdateEvent.createPromise();
    box.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map(function (it) { return { merchandiseId: it.id, quantity: it.quantity }; }),
        promise: deferred.promise,
      })
    );

    var addedSections;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (added) {
        if (added && added.status) throw new Error(added.description || added.message || 'Cart error');
        addedSections = added && added.sections;
        // /cart/add.js returns only the added lines; refetch the full cart for the count.
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var cartObj = null;
        try { cartObj = CartLinesUpdateEvent.createCartFromAjaxResponse(cart); } catch (_) { /* fall back to detail.itemCount */ }
        deferred.resolve({
          cart: cartObj,
          detail: {
            sections: addedSections,
            items: cart.items,
            itemCount: cart.item_count,
            source: 'soundium-complementary',
            didError: false,
          },
        });
        btn.classList.add('snd-cmp__add--added');
        var addedText = box.dataset.textAdded || 'Added ✓';
        if (label) label.textContent = addedText;
        setTimeout(function () {
          btn.classList.remove('snd-cmp__add--added');
          if (label) label.textContent = original;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        deferred.reject(err);
        btn.disabled = false;
        if (label) label.textContent = original;
        console.error('[soundium-complementary]', err);
      });
  }

  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('.snd-cmp__input');
    if (!inp) return;
    var box = inp.closest('.snd-cmp-bundle');
    if (box) recalc(box);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-add]');
    if (!btn) return;
    var box = btn.closest('.snd-cmp-bundle');
    if (box) handleAdd(btn, box);
  });

  function initAll() {
    document.querySelectorAll('.snd-cmp-bundle').forEach(recalc);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
